<template>
    <form action="post" @submit.prevent="UpdateData">
        <div class="row mb-3">
            <div class="col-12 col-md-6 mb-4">
                <div class="card card-body shadow">
                    <div class="row">
                        <div class="col-4">Pengajuan</div>
                        <div class="col-8">: {{ this.formsData.r_sub_kategori.nama }}</div>
                    </div>
                    <div class="row">
                        <div class="col-4">Pemohon</div>
                        <div class="col-8">: {{ this.formsData.r_pengajuan.nama }}</div>
                    </div>
                    <div class="row">
                        <div class="col-4">Instansi</div>
                        <div class="col-8">: {{ this.formsData.r_pengajuan.instansi }}</div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="card card-body shadow">
                    <div class="form-group mb-1">
                        <label>Kode Sampel</label>
                        <input type="text" class="form-control" v-model="data.kode_sampel">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="d-flex justify-content-end">
                <button class="btn bg-gradient-primary">Lanjut Ke Tunggu Antrian</button>
            </div>
        </div>
</form>
</template>

<script>















export default {
    name: "UjilabPengujianPengujian",
    data() {
        return {
            id: this.$route.params.id,
            data: {
                status: 'Menunggu Antrian'
            },
            formsData: {
                r_sub_kategori: '',
                r_pengajuan: '',
            },
        }
    },
    methods: {
        UpdateData() {
            this.axios.put('usulan/' + this.id, this.data).then((response) => {
                this.$swal.fire({ icon: 'success', title: response.data.message }).then(() => {
                    this.$router.push({ name: 'ujilab.pengujian' });
                });
            });
        }
    },
    mounted() {
        this.axios.get('usulan/' + this.id).then((response) => {
            this.formsData = response.data.data;
            this.data.jumlah = response.data.data.jumlah;
            this.data.kategori_id = response.data.data.kategori_id;
            this.data.subkategori_id = response.data.data.subkategori_id;
            this.data.kode_sampel = response.data.data.kode_sampel;
        });
    }
}
</script>